import { AkamLogoCheckIcon, AkamLogoTextIcon, InstagramIcon, TelegramIcon } from 'icons';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { globalConst } from 'modules/global';

const MainFooter = () => {
  const { locale = 'uz' } = useRouter();
  const t = globalConst.extraTranslation.footer[locale as 'uz' | 'ru'];

  return (
    <div className="bg-gray-800 py-12 text-gray-300">
      <div className="max-w-screen container mx-auto px-4">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <Link href="/" aria-label="Akam logo" className="mb-4 flex items-center gap-2">
              <AkamLogoCheckIcon />
              <AkamLogoTextIcon />
            </Link>
            <p className="text-md mt-4 max-w-xs font-medium leading-relaxed ">{t?.footer_title}</p>
          </div>

          {/* Contact Us */}
          <div className="mr-5">
            <h2 className="mb-4 text-lg font-medium text-white">{t?.contact_us}</h2>
            <div className="space-y-3 text-sm">
              <div>
                <span className="text-gray-400">{t?.contact}: </span>
                {/* eslint-disable-next-line i18next/no-literal-string */}
                <div className="flex flex-col gap-1">
                  <Link href="tel:+998942508101" target="_blank">
                    +998 94 250 81 01
                  </Link>
                  <Link href="tel:+998917979749" target="_blank">
                    +998 91 797 97 49
                  </Link>
                </div>
              </div>
              <div>
                <span className="text-gray-400">{t?.address}:</span>
                {/* eslint-disable-next-line i18next/no-literal-string */}
                <span> {t?.location}</span>
              </div>
            </div>
          </div>

          {/* Social */}
          <div>
            <h3 className="mb-4 text-lg font-medium text-white">{t?.social}</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Link
                  href="https://www.instagram.com/akam.uz/"
                  target="_blank"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  <span className="flex items-center gap-1 text-gray-400 hover:text-white">
                    {' '}
                    {/* eslint-disable-next-line i18next/no-literal-string */}
                    <InstagramIcon />
                    Instagram
                  </span>
                </Link>
              </div>
              <div className="flex items-center gap-2">
                <Link
                  href={`${process.env.NEXT_PUBLIC_TELEGRAM}`}
                  target="_blank"
                  className="text-gray-300 transition-colors hover:text-white"
                >
                  <span className="flex items-center gap-1 text-gray-400 hover:text-white">
                    {' '}
                    {/* eslint-disable-next-line i18next/no-literal-string */}
                    <TelegramIcon width="18" height="15" />
                    Telegram
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainFooter;
